{
  "nl": {
    "validations": {
      "dialogFormat": "Markeer beide sprekers met **Naam**: aan het begin van de regel, gevolgd door de gesproken tekst. Eén regel per spreekbeurt en geen verdere **-markeringen in de tekst.",
      "email": "Voer een geldig e-mailadres in.",
      "embeddedAppNotFound": "De ingesloten inhoud kon niet worden gevonden.",
      "groupCountTooLarge": "Het aantal groepen moet lager zijn dan het aantal namen.",
      "groupSizeTooLarge": "Het aantal leden per groep moet lager zijn dan het aantal namen.",
      "groupSizeTooSmall": "Het aantal groepen overschrijdt het maximum van 20. Verhoog het aantal leden per groep of verlaag het aantal namen.",
      "integer": "Voer een geheel getal in.",
      "isYoutubeOrVimeoUrl": "Voer een geldige YouTube- of Vimeo-URL in.",
      "linkedAppNotFound": "De gelinkte inhoud kon niet worden gevonden.",
      "maxLength": "Maximaal {max} selecteerbaar",
      "maxLengthValue": "Maximale lengte is {max} tekens.",
      "minLength": "Minimaal {min} letters",
      "namesCountTooLarge": "Je kunt maximaal 100 namen invoeren.",
      "namesCountTooSmall": "Je moet minimaal twee namen invoeren.",
      "required": "Dit veld is verplicht.",
      "requiredIf": "Dit veld is verplicht.",
      "tooManyWords": "Voer maximaal {count} woorden in.",
      "url": "Voer een geldige URL (incl. https://) in.",
      "validEmbedCode": "Voer een geldige URL of een iFrame-codefragment in.",
      "validUrl": "Voer een geldige URL in.",
      "maxValue": "De waarde mag maximaal {max} zijn.",
      "minValue": "De waarde moet minimaal {min} zijn.",
      "youtubeOrVimeoUrl": "Voer een geldige YouTube- of Vimeo-URL in."
    }
  }
}
